export default class SaveDataSlot {
    /**
     * @param {number} id
     */
    constructor(id) {
        this._id = id;

        this.player = { tutorial: true, mapTutorial: true, lastLocation:null, effects:{}, hat:null, weapon:null, lastQuest:null};
        this.quests = {};
        this.inventory = {};
        this.coins = 10;
        this.acorns = [];
        this.treasures = [];
        this.goldenTurnips = [];
        this.purchases = {};
        this.unlocks = [];
        this.settings = {};
    }

    /**
     * @return {object}
     */
    toObject() {
        return {
            player: this.player,
            quests: this.quests,
            inventory: this.inventory,
            coins: this.coins,
            acorns: this.acorns,
            treasures: this.treasures,
            goldenTurnips: this.goldenTurnips,
            purchases: this.purchases,
            unlocks: this.unlocks,
            settings: this.settings
        };
    }

    /**
     * @return {number}
     */
    get id() {
        return this._id;
    }
}